import React, {Component} from "react"
import {connect} from "react-redux";
import {get_premium_history} from "../actions/premium";
import {get_user_info} from "../actions/auth";

class CheckPremiumTimer extends Component {
    componentDidMount() {
        this.timer = setInterval(() => {
            this.props.get_premium_history();
            this.props.get_user_info();
        }, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    {get_premium_history, get_user_info}
)(CheckPremiumTimer);
